export default {
    route: {
      Dashboard: '首页',
      Setting: '配置中心',
      Business: '业务中心',
      SettingUser: '用户管理',
      SettingUserOrganization: '组织架构',
      SettingUserAccount: '账号安全策略',
      SettingGoods: '商品管理',
      SettingGoodsAudit: '产品审核策略', // '商品审核策略',
      SettingStock: '库存管理',
      SettingStockStructure: '仓库结构配置',
      SettingStockRatio: '仓库比例配置',
      SettingStockAudit: '仓库审核策略',
      SettingStockRules: '库存规则',
      SettingLogistics: '物流管理',
      SettingLogisticsStrategy: '物流策略',
      SettingLogisticsStrategyAuthorize: '物流授权',
      SettingOrder: '订单管理',
      SettingOrderSourceStrategy: '寻源策略',
      SettingOrderSourceDeploy: '寻源配置',
      SettingFinance: '财务管理',
      SettingFinanceStatement: '对账基础配置',
      SettingFinanceAnalysis: '平台账单解析策略',
      SettingBaseData: '基础数据',
      SettingBaseDataConfig: '系统应用',
      SettingBaseDataCodeRule: '编码规则',
      SettingBaseDataCountry: '国家定义',
      SettingBaseDataRegion: '行政区定义',
      SettingBaseDataAfterSalesReason: '售后原因',
      SettingBaseDataLov: '值集',
      SettingIndexes: '索引配置',
      SettingIndexesConfig: '索引配置列表',
      SettingInquiry: '查询配置',
      SettingIndexesSync: '索引同步',
      SettingFile: '文件',
      SettingFileSearch: '汇总查询',
      SettingFileStorage: '存储配置',
      SettingFileUploadRam: '上传容量配置',
      SettingFileUploadConfig: '上传详情配置',
      SettingInstance: '事务',
      SettingInstanceManage: '事务列表',
      SettingWorkflow: '工作流',
      SettingWorkflowBpmn: '工作流设计',
      SettingTenant: '租户管理',
      SettingTenantManage: '租户',
      SettingTenantManageIndex: '租户列表',
      SettingTenantManageAdd: '添加租户',
      SettingTenantManageEdit: '编辑租户',
      SettingBaseDataRefreshService: '刷新服务权限',
      SettingBaseDataRefreshServiceIndex: '刷新服务权限',
      SettingBaseDataExchangeRate: '汇率维护',
      BusinessUser: '用户', // '账号',
      BusinessUserAccount: '账户',
      BusinessUserAccountCSG: '账户',
      BusinessUserRole: '角色',
      BusinessUserRoleAdminCSG: '角色',
      BusinessUserCustomerCSG: '客户',
      BusinessChannel: '渠道',
      BusinessPlatForm: '渠道',
      BusinessInbound: '入库',
      BusinessChannelOnline: '网店',
      BusinessChannelOnlineCsg: '店铺',
      BusinessChannelOnlineCsgAdmin: '店铺',
      BusinessChannelExternalPlatformOrders: '外部平台订单',
      BusinessChannelEDIOrders: 'EDI订单平台',
      BusinessChannelPhysical: '门店',
      BusinessChannelStorage: '仓储',
      BusinessChannelWarehouse: '渠道仓',
      BusinessGoods: '商品',
      BusinessGoodsSpu: '商品',
      BusinessGoodsSku: 'SKU',
      CSGGoodsSku: '产品',
      BusinessGoodsClassify: '分类',
      BusinessGoodsBrand: '品牌',
      BusinessGoodsMaterial: '素材',
      BusinessGoodsPriceItem: '价格项',
      BusinessGoodsAudit: '商品审核',
      BusinessGoodsAuditCSG: '产品审核',
      BusinessStock: '库存',
      BusinessStockSearch: '库存查询',
      BusinessStockSearchCSG: '库存查询',
      BusinessStockUserCsg: '用户板数',
      BusinessBatchInventoryQuery: '批次库存查询',
      BusinessBatchShipmentecord: '批次库存发货记录',
      BusinessStorageTransactionReport: '存储记录',
      BusinessStockChange: '库存变动查询',
      BusinessStockMovement: '库存变动',
      BusinessStockChangeCSG: '库存变动查询',
      BusinessStockEntry: '入库',
      BusinessStockDelivery: '出库',
      BusinessStockConsign: '打单发货',
      BusinessStockTransfer: '调拨',
      BusinessStockLock: '预留锁定',
      BusinessStockVerify: '库存变动审核',
      BusinessStockDistribution: '商品分配',
      BusinessStockSynchronization: '数据同步',
      BusinessLogistics: '物流',
      BusinessLogisticsCompany: '物流商',
      BusinessLogisticsCompanyCSGUser: '物流商',
      BusinessLogisticsCompanyCSGAdmin: '物流商',
      BusinessOrder: '出库',
      BusinessOrderInternal: '内部订单', // '内部销售单',
      BusinessOrderInternalCSGAdmin: '已完成订单', // '已完成订单',
      BusinessOrderInternalCSGFEE: '费用信息', // '费用信息',
      BusinessOrderInternalCSGUser: '订单处理', // '内部销售单',
      BusinessOrderInternalErrorCSGAdmin: '异常订单', // '内部销售单',
      BusinessOrderAudit: '待审核销售单',
      BusinessOrderPreempt: '预占',
      BusinessOrderSource: '寻源',
      BusinessOrderShort: '缺货订单',
      BusinessOrderShortCSG: '缺货订单',
      Order: '异常订单',
      BusinessETAQuery: 'ETA 查询',
      BusinessOrderSend: '订单推送',
      BusinessThird: '外部',
      BusinessThirdGoods: '外部商品',
      BusinessThirdOrder: '外部订单', // '外部销售单',
      BusinessThirdOrderCSGAdmin: '订单列表', // '外部销售单',
      BusinessThirdOrderCSGUser: '订单列表', // '外部销售单',
      BusinessThirdO2o: '外部O2O订单',
      BusinessThirdAfter: '外部售后单',
      BusinessThirdMapOutStore: '外部店铺映射',
      BusinessAfterCsgReturnIndex: '退货订单',
      BusinessAfterCsgReturnView: '退货单详情',
      BusinessAfterCsgReturnAdd: '新增退货单',
      BusinessAfterCsgReturnEdit: '编辑退货单',
      BusinessAfterReturnList: '退件列表',
      BusinessOpenReturnList: '未完成退件',
      BusinessCloseReturnList: '已完成退件',
      BusinessAfterReturnView: '退件详情',
      BusinessAfterReturnConfim: '仓库人员确认',
      BusinessAfterReturnAdd: '新增退件',
      BusinessAfterReturnEdit: '编辑退件',
      BusinessAfterCsgAdminReturnIndex: '退货订单',
      BusinessAfterCsgAdminReturnView: '退货单详情',
      BusinessAfterCsgAdminReturnAdd: '新增退货单',
      BusinessAfterCsgAdminReturnEdit: '编辑退货单',
      BusinessAfterCsgAdminReturnConfim: '确认退货单',
      BusinessWorkOrderAudit: '工单审核按钮',
      BusinessO2o: 'O2O订单',
      BusinessO2oInternal: '内部O2O订单',
      BusinessO2oAudit: '待审核O2O订单',
      BusinessAfter: '售后',
      BusinessAfterInternal: '内部售后单',
      BusinessAfterAudit: '待审核售后单',
      BusinessFinance: '财务',
      BusinessFinancePlatformOriginal: '平台账单（原始）',
      BusinessFinancePlatform: '平台账单',
      BusinessFinanceChecking: '平台对账',
      BusinessLabel: '标签',
      BusinessLabelSys: '系统标签',
      BusinessLabelHand: '人工标签',
      BusinessMarketing: '营销',
      BusinessMarketingActivity: '赠品活动',
      BusinessMarketingGift: '随品规则',
      BusinessReport: '报表',
      BusinessBIReport: 'BI报表',
      BusinessBIReportIndex: 'CSG Profit Analysis Report',
      BusinessBIReportCSGProfitAnalysisReport: 'Profit Analysis',
      BusinessBIReportTicketCompletionPerformanceReport: 'Profit Analysis - Net',
      BusinessBIReportWarehousePerformanceReport: 'Ticket Performance',
      BusinessBIReportProfitAnalysisReport: 'Warehouse Performance',
      BusinessBIReportNewCompletionPerformanceReport: 'New Profit Analysis - Net',
      BusinessSalesDaily: 'BI销售报表',
      BusinessSalesDailyIndex: '销售日报',
      BusinessSalesDailyWeekSalesReport: '销售周报利润分析报表',
      BusinessSalesDailyMonthlyAnalysisReport: '销售月报分析',
      BusinessSalesDailySelloProfitMetricMonitor: '利润指标监控报表',
      BusinessSalesDailyWarehouseBIReport: '仓库报表',
      BusinessSalesDailySkuPurchaseAnalysisReport: 'Sku采购分析支持报表',
      BusinessSalesDailyLossOrderAnalysis: 'Loss订单分析报表',
      BusinessSalesDailySalesAnalysis: '销售分析按Shipping Zone',
      BusinessSalesDailyDetailDown: '明细数据下载',
      BusinessInventoryReport: 'A类产品库存周报',
      BusinessReportSale: '销售',
      BusinessReportSaleCSG: '订单报表',
      BusinessReportStock: '库存',
      BusinessReportOrder: '订单',
      BusinessReportOrderIndex: '订单统计表',
      BusinessOrderTimeliness: '订单时效',
      BusinessOrderTimelinessAverage: '处理时长表',
      BusinessOrderTimelinessOnTime: '按时处理率表',
      BusinessOrderWarehouseEfficiency: '仓库时效',
      BusinessOrderWarehousePickerRank: '拣货员排名',
      BusinessOrderrWarehouseForkliftDriver: '叉车手排名',
      BusinessImport: '导入',
      BusinessImportHistory: '导入历史',
      BusinessImportGeneral: '通用导入',
      BusinessPurchase: '采购',
      BusinessQuotation: '报价',
      BusinessPayment: '账期',
      BusinessPaymentProcessingIndex: '账期处理',
      BusinessPaymentStatisticsIndex: '账期统计',
      BusinessBilling: '账单',
      BusinessBillingPrice: '客户报价单',
      BusinessBillingServiceInvoices: '客户账单',
      BusinessBillingCategories: '收费项',
      BusinessBillingProfileTemplates: '收费模版',
      BusinessBillingClientProfiles: '用户收费模版',
      BusinessBillingTransactions: '计费流水',
      BusinessBillingDeposit: '钱包',
      BusinessBillingMyDeposit: '我的钱包',
      BusinessBillingDeposiInfo: '钱包信息',
      BusinessBillingClientAccounts: '客户账户信息',
      BusinessBillingCustomerInventoryPricing: '库存价值',
      BusinessBillingCostExpenditureStatistics: '成本支出统计',
      BusinessBillingCostItem: '成本项',
      BusinessBillingPreviewInvoices: '待确认账单',
      BusinessBillingInvoiceReview: '发票审核',
      BusinessBillingInvoices: '发票',
      BusinessBillingAdditionalCharge: '增值服务',
      BusinessBillingCredit: '信用票据',
      BusinessBillingExpense: '开支管理',
      BusinessBillingHistorical: '成本列表',
      BusinessBillingHistoricaCost: '历史成本',
      BusinessBillingRegularSurcharge: '收费策略',
      BusinessBillingInvoiceStatement: '发票声明',
      BusinessBillingShippingCharges: '运费比较',
      BusinessBillingPostageRecharge: '邮费收费',
      BusinessBillingPostageRechargeDetail: '邮费收费详情',
      BusinessBillingStorageReport: '存储报告',
      BusinessBillingDeliveryNote: '出货单',
      BusinessBillingServiceItem: '服务项目',
      BusinessBillingAddDeliveryNote: '新增出货单',
      BusinessBillingInvoiceReport: '发票报表',
      BusinessBillingTierSetting: '档位配置',
      BusinessBillingOperationLog: '操作日志',
      BusinessBillingPostage: '邮费对比',
      BusinessOrderPostagDetail: '邮费对比详情',
      WMSPage: 'WMS',
      WMSWavePage: '波次列表',
      WMSWaveDetail: '波次详情',
      WMSSortingStation: '分拣台列表',
      WMSNSTD: 'NSTD',
      WMSLampRack: '灯架配置',
      customerMenu: '客户',
      onboardingDashboard: '入场客户面板',
      onboardingPageIndex: '入场客户',
      BusinessHelp: '用户手册',
      BusinessHelpManual: '用户手册',
      BusinessPurchaseSupplier: '供应商',
      BusinessPurchaseSupplierShop: '供应商商品',
      BusinessPurchaseForecast: '采购预测',
      BusinessInventoryPrediction: '库存预测报告',
      BusinessPurchaseApply: '采购申请单',
      BusinessPurchaseOrder: '采购单',
      BusinessPurchaseOrderCsgAdminclosedIndex: '已完成入库单',
      BusinessPurchaseOrderCsgAdminIndex: '未完成入库单',
      BusinessPurchaseOrderTimeConfigure: '入库时间配置',
      BusinessPurchaseTemporaryNot: '未完成临时存储',
      BusinessPurchaseTemporaryYet: '已完成临时存储',
      BusinessPurchaseDetailCsg: '入库单详情',
      BusinessPurchaseOrderCsgAdminDetail: '入库单详情',
      BusinessPurchaseOrderCsgAdminReceive: '查询入库单',
      BusinessPurchaseEntry: '采购入库单',
      BusinessPurchaseGetLow: '统计SKU降低成本',
      BusinessPurchaseTimeliness: '返单及时率',
      BusinessPurchaseReturn: '采购退货单',
      BusinessQuotationBasics: '基础配置',
      BusinessPurchaseBasics: '基础配置',
      BusinessQuotationHistory: '历史数据',
      BusinessQuotationQuoteIndex: '报价单',
      BusinessQuotationQuoteDetail: '报价单详情',
      BusinessQuotationQuoteAdd: '新增报价单',
      BusinessQuotationQuoteEdit: '编辑报价单',
      SettingUserOrganizationGroup: '集团设置',
      SettingUserOrganizationCompany: '下属公司',
      SettingUserAccountStrategy: '账号安全策略配置',
      SettingStockRatioConfig: '库存比例配置',
      SettingStockAuditStrategy: '库存审核策略',
      SettingStockRulesConfig: '库存规则',
      SettingLogisticsStrategyConfig: '物流策略',
      SettingOrderSourceStrategySourcing: '寻源规则',
      SettingOrderSourceStrategyParcel: '包裹规则',
      SettingOrderSourceDeployConfig: '寻源配置',
      SettingBaseDataConfigIndex: '系统应用',
      SettingBaseDataCodeRuleIndex: '编码规则',
      SettingBaseDataAfterSalesReasonRefundIndex: '仅退款原因',
      SettingBaseDataAfterSalesReasonReturnIndex: '退货退款原因',
      SettingBaseDataLovHeaderIndex: '值集头',
      SettingFileUploadConfigIndex: '上传详细配置',
      BusinessUserRoleIndex: '角色',
      BusinessChannelOnlineIndex: '网店',
      BusinessChannelOnlineTripartite: '三方平台',
      BusinessChannelOnlineFlowDistribution: '分配物流',
      BusinessChannelOnlineFlowDistributionCsg: '分配物流',
      BusinessChannelOnlineFlowDistributionCsgAdmin: '分配物流',
      BusinessChannelOnlinePriceManagement: '网店商品价格',
      BusinessChannelPhysicalIndex: '门店',
      BusinessChannelStorageIndex: '仓储',
      BusinessGoodsSpuOrdinaryIndex: '普通商品',
      BusinessGoodsSpuPackageIndex: '组合商品',
      BusinessGoodsSkuOrdinaryIndex: '普通SKU列表',
      CSGGoodsSkuOrdinaryIndex: '普通产品',
      BusinessGoodsSkuPackageIndex: '套餐SKU列表',
      CSGGoodsSkuPackageIndex: '组合产品',
      BusinessGoodsSkuDraftIndex: '草稿SKU列表',
      BusinessGoodsPackageManagement: '包材管理',
      BusinessGoodsClassifyIndex: '分类',
      BusinessGoodsBrandIndex: '品牌',
      BusinessGoodsMaterialIndex: '素材',
      BusinessGoodsPriceItemIndex: '价格项',
      BusinessGoodsAuditSkuOrdinaryIndex: '商品SKU审核',
      BusinessGoodsAuditSkuOrdinaryCSGIndex: '普通产品审核',
      BusinessGoodsAuditSkuPackageIndex: '套餐SKU审核',
      BusinessGoodsAuditSkuPackageCSGIndex: '组合产品审核',
      BusinessStockSearchIndex: '库存查询',
      BusinessStockChangeIndex: '库存变动查询',
      BusinessStockEntryInformIndex: '入库通知单',
      BusinessStockEntryResultIndex: '入库结果单',
      BusinessStockDeliveryInformIndex: '出库通知单',
      BusinessStockDeliveryResultIndex: '出库结果单',
      BusinessStockConsignIntimidate: '打单发货',
      BusinessStockConsignCheck: '检验发货',
      BusinessStockTransferVirtualIndex: '虚仓移仓',
      BusinessStockLockIndex: '预留锁定',
      BusinessStockVerifyVirtualIndex: '虚仓移仓审核',
      BusinessStockVerifyLockIndex: '库存预留审核',
      BusinessStockVerifyPlanIndex: '分仓计划审核',
      BusinessStockDistributionQtyIndex: '仓位数量分配',
      BusinessStockDistributionRatioIndex: '仓位比例分配',
      BusinessStockDistributionPlanIndex: '分仓计划',
      BusinessStockSynchronizationIndex: '数据同步',
      BusinessStockInventoryWarning: '库存预警',
      BusinessAbnormalOrderIndex: '未完成订单',
      BusinessAbnormalOrderTIMEOUT: '预占超时',
      BusinessAbnormalOrderANOMALY: '异常订单',
      BusinessAbnormalOrderSTOCK: '新订单',
      BusinessAbnormalOrderOUTOFSTOCK: '缺货订单',
      BusinessAbnormalOrderWAIRING: '等待发货',
      BusinessAbnormalOrderCOLLECTPENDING: '等待取货',
      BusinessAbnormalOrderCOLLECTPENDINGLabel: '已上传面单',
      BusinessAbnormalOrderEXCEPTION: '推送异常',
      BusinessAbnormalOrderPROCESSINGOrder: '处理中订单',
      BusinessSystemOnlineNotification: '系统上线通知',
      BusinessSystemOnlineNotificationDetailAdd: '新增通知详情',
      BusinessSystemOnlineNotificationDetailEdit: '编辑通知详情',
      BusinessAbnormalOrderALL: '全部订单',
      BusinessAbnormalOrderPendingHJCancel: '待HJ取消',
      BusinessAbnormalOrderUrgent: '加急',
      BusinessAbnormalOrderHUNT: '待手动取消',
      BillingPageInvoiceReportTotal: '总计',
      BillingPageInvoiceReportPallet: '托盘',
      BillingPageInvoiceReportCBM: 'CBM',
      BillingPageInvoiceReportClientQty: '客户数量',
      BillingPageInvoiceReportClient: '客户',
      BillingPageInvoiceReportPostage: '邮费',
      BillingPageInvoiceReportSales: '销售',
      BusinessLogisticsCompanyListIndex: '物流商列表',
      BusinessLogisticsCompanyListIndexCSGUser: '物流商列表',
      BusinessLogisticsCompanyListIndexCSGAdmin: '物流商列表',
      BusinessLogisticsCompanyBusinessIndex: '物流业务',
      BusinessLogisticsCompanyBusinessIndexCSGUser: '物流业务',
      BusinessLogisticsCompanyBusinessIndexCSGAdmin: '物流业务',
      BusinessLogisticsCompanyBusinessSetting: '派送渠道设置',
      BusinessLogisticsImport: '物流信息导入',
      BusinessLogisticsRate: '物流费率',
      BusinessLogisticsRateIndex: '物流费率',
      BusinessLogisticsRateAdd: '新增物流费率',
      BusinessLogisticsRateView: '物流费率详情',
      BusinessLogisticsNewRate: '物流费率',
      BusinessLogisticsNewRateIndex: '物流费率',
      BusinessLogisticsZone: '区域分组',
      BusinessLogisticsZoneIndex: '区域分组',
      BusinessLogisticsZoneDetail: '区域明细',
      BusinessLogisticsZoneImportFile: '区域数据导入',
      BusinessLogisticsProduct: '物流产品',
      BusinessLogisticsProductSetting: '产品设置',
      BusinessLogisticsCompanyPostCodeIndex: '邮编',
      BusinessLogisticsCompanyPostCodeIndexCSGUser: '邮编',
      BusinessLogisticsCompanyPostCodeIndexCSGAdmin: '邮编',
      BusinessLogisticsCompanyManagementIndexCSGAdmin: '客户物流',
      BusinessLogisticsCompanyRelationIndex: '运费关联设置',
      BusinessLogisticsCompanyFreightIndex: '运费模板',
      BusinessLogisticsCompanyMapping: '物流映射',
      BusinessOrderInternalIndex: '内部订单',
      BusinessOrderAuditIndex: '待审核销售单',
      BusinessOrderBookLogistic: '物流下单',
      BusinessOrderPreemptIndex: '预占',
      BusinessOrderSourceIndex: '寻源',
      BusinessOrderShortIndex: '缺货订单',
      BusinessThirdGoodsIndex: '外部平台商品',
      BusinessThirdOrderIndex: '外部销售单',
      BusinessThirdO2oIndex: '外部O2O订单',
      BusinessThirdAfterIndex: '外部售后单',
      BusinessThirdStoreMappingIndex: '外部店铺映射',
      BusinessO2oInternalIndex: '内部O2O订单',
      BusinessO2oAuditIndex: '待审核O2O订单',
      BusinessAfterInternalRefundIndex: '内部仅退款',
      BusinessAfterInternalReturnIndex: '内部退货退款',
      BusinessAfterInternalReship: '重新发货',
      BusinessAfterAuditRefundIndex: '仅退款待审核',
      BusinessAfterAuditReturnIndex: '退货退款待审核',
      BusinessFinancePlatformOriginalTmallIndex: '天猫账单',
      BusinessFinancePlatformOriginalJdcomIndex: '京东账单',
      BusinessFinancePlatformListIndex: '平台账单',
      BusinessFinanceCheckingDoneIndex: '已对账列表',
      BusinessFinanceCheckingActionIndex: '对账处理',
      BusinessLabelSysIndex: '系统标签',
      BusinessLabelHandIndex: '人工标签',
      BusinessMarketingActivityIndex: '赠品活动列表',
      BusinessMarketingGiftIndex: '随品规则列表',
      BusinessReportSaleCensusIndex: '销售统计表',
      BusinessReportSaleCensusIndexCSG: '销售统计表',
      BusinessReportSaleAnalysisIndex: '销售分析表',
      BusinessReportSaleGoodsIndex: '销售商品统计表',
      BusinessReportSaleShopIndex: '店铺销售表',
      BusinessReportStockDeliverIndex: '发货汇总表',
      BusinessReportStockOutIndex: '缺货统计表',
      BusinessImportHistoryIndex: '导入历史列表',
      BusinessImportGeneralIndex: '通用导入列表',
      BusinessPurchaseSupplierIndex: '供应商',
      BusinessPurchaseSupplierShopIndex: '供应商商品',
      BusinessPurchaseApplyIndex: '采购申请单',
      BusinessPurchaseOrderIndex: '采购单',
      BusinessPurchaseEntryInform: '采购入库通知单',
      BusinessPurchaseEntryResult: '采购入库结果单',
      BusinessPurchaseReturnInform: '采购退货出库通知单',
      BusinessPurchaseReturnResult: '采购退货出库结果单',
      SettingLogisticsStrategyOrderMoneyIndex: '设置订单金额',
      SettingLogisticsStrategyZonesIndex: '设置省市区',
      SettingLogisticsStrategyWarehouseIndex: '设置仓库',
      SettingLogisticsStrategyAssignGoodsIndex: '设置指定商品',
      SettingBaseDataCodeRuleEdit: '编码规则-编辑',
      SettingWorkflowBpmnAdd: '新增工作流',
      SettingWorkflowBpmnEdit: '编辑工作流',
      BusinessUserAccountAdd: '新建账户',
      BusinessUserAccountAddCSG: '新建账户',
      BusinessUserAccountCustom: '新建客户',
      BusinessUserCustomerAddCSG: '新建客户',
      BusinessUserCustomerEditCSG: '编辑客户',
      BusinessUserCustomerOffline: '下线客户',
      BusinessUserAccountOffline: '下线账户',
      BusinessStorageExportCBM: '库存查询导出按钮',
      BusinessUserDepartment: '部门管理',
      BusinessUserDepartmentBackup: '客户文件',
      BusinessUserDepartmentBackupDetail: '客户文件详情',
      BusinessUserStaffManagement: '仓库人工管理',
      BusinessUserDeptManagement: '仓库部门管理',
      BusinessUserHourManagement: '用工管理',
      QuotationCenterManagement: '报价',
      BusinessQuotationSupplier: '供应商报价',
      BusinessQuotationDetails: '报价明细',
      BusinessQuotationShippingCost: '运费',
      BusinessQuotationOtherCost: '其他费',
      BusinessQuotationTrialCalculation: '试算',
      BusinessQuotationCustomer: '客户标准报价',
      BusinessQuotationCustomerDetails: '报价明细',
      BusinessQuotationCustomerShippingCost: '运费',
      BusinessQuotationCustomerOtherCost: '其他费',
      BusinessQuotationCustomerTrialCalculation: '试算',
      BusinessQuotationVIPCustomer: 'VIP客户报价',
      BusinessFuelSurchargeRate: '燃油附加费费率维护',
      BusinessUserTimeManagement: '工时管理',
      BusinessUserDepartPosition: '岗位管理',
      BusinessUserfunConfig: '客户功能配置',
      BusinessUserfunConfigInfo: '客户功能配置详情',
      BusinessUserAccountEdit: '编辑账户',
      BusinessUserAccountEditCSG: '编辑账户',
      BusinessUserAccountEditCustom: '编辑账户',
      BusinessUserRoleAllotUser: '分配用户',
      BusinessUserRoleAllotUserCSG: '分配用户',
      BusinessUserRoleAllotMenu: '分配菜单权限',
      BusinessUserRoleAllotMenuCSG: '分配菜单权限',
      BusinessGoodsSpuOrdinaryAdd: '添加普通商品',
      BusinessGoodsSpuOrdinaryEdit: '编辑普通商品',
      BusinessGoodsSpuPackageAdd: '添加组合商品',
      BusinessGoodsSpuPackageEdit: '编辑组合商品',
      BusinessGoodsSpuPackageView: '组合商品详情',
      BusinessGoodsSkuOrdinaryAdd: '添加普通产品',
      CSGGoodsSkuOrdinaryAdd: '添加普通产品',
      BusinessGoodsSkuOrdinaryEdit: '编辑普通产品',
      CSGGoodsSkuOrdinaryEdit: '编辑普通产品',
      BusinessGoodsSkuOrdinaryView: '普通产品详情',
      CSGGoodsSkuOrdinaryView: '普通产品详情',
      BusinessGoodsSkuPackageAdd: '添加组合产品',
      CSGGoodsSkuPackageAdd: '添加组合产品',
      BusinessGoodsSkuPackageEdit: '编辑组合产品',
      CSGGoodsSkuPackageEdit: '编辑组合产品',
      BusinessGoodsSkuPackageView: '组合产品详情',
      CSGGoodsSkuPackageView: '组合产品详情',
      BusinessGoodsAuditSkuOrdinaryView: '查看商品SKU审核详情',
      BusinessGoodsAuditSkuOrdinaryCSGView: '查看普通产品审核详情',
      BusinessGoodsAuditSkuOrdinaryAudit: '审核商品SKU审核详情',
      BusinessGoodsAuditSkuOrdinaryCSGAudit: '审核普通产品审核详情',
      BusinessGoodsAuditSkuPackageView: '查看套餐SKU审核详情',
      BusinessGoodsAuditSkuPackageCSGView: '查看组合产品审核详情',
      BusinessGoodsAuditSkuPackageAudit: '审核套餐SKU审核详情',
      BusinessGoodsAuditSkuPackageCSGAudit: '审核组合产品审核详情',
      BusinessStockDistributionQtyAddSku: '仓位数量分配-商品分配',
      BusinessStockDistributionQtyAddWarehouse: '仓位数量分配-批量分配',
      BusinessStockDistributionQtyView: '查看仓位数量分配',
      BusinessStockDistributionQtyEdit: '编辑仓位数量分配',
      BusinessStockSynchronizationDetail: '数据同步详情',
      BusinessLogisticsCompanyFreightEdit: '编辑运费模板',
      BusinessOrderInternalAdd: '销售单录入',
      BusinessOrderInternalAddCSG: '复制订单',
      BusinessOrderInternalEditCSG: '订单编辑',
      BusinessThirdOrderView: '外部订单详情',
      BusinessThirdOrderCSGView: '订单列表详情',
      BusinessThirdOrderCSGViewUser: '订单列表详情',
      BusinessThirdCopyOrderView: '重发单',
      BusinessAddThirdOrderView: '新增外部订单',
      BusinessAddThirdOrderCSGView: '新增外部订单',
      BusinessAddThirdOrderCSGViewUser: '新增外部订单',
      BusinessThirdReissueOrderView: '补发单',
      BusinessOrderInternalView: '内部订单详情',
      BusinessOrderInternalViewCSG: '订单处理详情',
      BusinessOrderInternalViewCSGUser: '订单处理详情',
      BusinessOrderInternalViewLoss: '亏损订单详情',
      BusinessAfterInternalRefundAdd: '新增内部仅退款单',
      BusinessAfterInternalReturnAdd: '新增内部退货退款单',
      BusinessOrderPreemptView: '预占详情',
      BusinessOrderSourceView: '寻源详情',
      BusinessThirdO2oAdd: '外部O2O订单录入',
      BusinessAfterInternalRefundView: '内部仅退款单详情',
      BusinessThirdAfterView: '外部售后单详情',
      BusinessAfterInternalReturnView: '内部退货退款单详情',
      BusinessImportGeneralEdit: '编辑通用模板',
      BusinessPurchaseApplyDetail: '采购申请单详情',
      BusinessPurchaseApplyIndexAdd: '新增采购申请单',
      BusinessPurchaseApplyIndexEdit: '编辑采购申请单',
      BusinessPurchaseApplyIndexCopy: '复制采购申请单',
      BusinessPurchaseOrderCsgAdd: '新增入库单',
      BusinessPurchaseOrderCsgAdminAdd: '新增入库单',
      BusinessPurchaseOrderIndexDetail: '采购单详情',
      BusinessPurchaseDetail: '采购单详情',
      BusinessPurchaseEntryInformAdd: '新增采购入库通知单',
      BusinessPurchaseEntryInformEdit: '编辑采购入库通知单',
      BusinessPurchaseEntryInformDetail: '采购入库通知单详情',
      BusinessPurchaseReturnInformAdd: '新增采购退货单',
      BusinessPurchaseReturnInformEdit: '编辑采购退货单',
      BusinessPurchaseReturnInformDetail: '采购退货通知单详情',

      SettingStockStructureView: '仓库结构配置详情',
      BusinessAfterInternalExchangeAdd: '新增内部换货单',
      BusinessAfterInternalExchangeView: '内部换货单详情',
      BusinessFinanceCheckingDoneView: '对账单详情',
      BusinessGoodsSpuOrdinaryView: '普通商品详情',
      BusinessImportGeneralAdd: '新增通用模板',
      BusinessImportGeneralColumn: '模板列',
      BusinessLogisticsCompanyFreightAdd: '新建运费模板',
      BusinessPurchaseApplyChangePurchase: '转采购单',
      BusinessPurchaseOrderCsgEdit: '修改入库单',
      BusinessPurchaseOrderCsgAdminEdit: '修改入库单',
      BusinessPurchaseOrderCsgAdminVerify: '尺寸校验',
      BusinessPurchaseEntryResultDetail: '采购入库结果单详情',
      BusinessPurchaseReturnResultDetail: '采购退货结果单详情',
      BusinessStockEntryInformView: '入库通知单详情',
      BusinessStockEntryResultView: '入库结果单详情',
      BusinessStockDeliveryInformView: '出库通知单详情',
      BusinessStockDeliveryResultView: '出库结果单详情',
      BusinessStockTransferLogicIndex: '逻辑仓调拨',
      BusinessStockTransferLogicAdd: '新建逻辑仓调拨',
      BusinessStockTransferLogicEdit: '编辑逻辑仓调拨',
      BusinessStockTransferLogicView: '逻辑仓调拨详情',
      BusinessStockTransferVirtualAdd: '新建虚仓移仓',
      BusinessStockTransferVirtualEdit: '编辑虚仓移仓',
      BusinessStockTransferVirtualView: '虚仓移仓详情',
      BusinessStockLockAdd: '新建预留锁定单',
      BusinessStockLockView: '预留锁定单详情',
      BusinessStockVerifyLogicIndex: '逻辑仓调拨审核',
      BusinessStockVerifyLogicView: '逻辑仓调拨审核详情',
      BusinessStockVerifyVirtualView: '虚仓移仓审核详情',
      BusinessStockVerifyLockView: '库存预留审核详情',
      BusinessStockVerifyPlanView: '分仓计划审核详情',
      BusinessStockDistributionRatioAddSku: '商品分配-仓位比例分配',
      BusinessStockDistributionRatioAddWarehouse: '批量分配-仓位比例分配',
      BusinessStockDistributionRatioEdit: '编辑仓位比例分配',
      BusinessStockDistributionRatioView: '查看仓位比例分配',
      BusinessStockDistributionPlanAdd: '新建分仓计划',
      BusinessStockDistributionPlanEdit: '编辑分仓计划',
      BusinessStockDistributionPlanView: '查看分仓计划',
      BusinessStockSynchronizationAdd: '新建数据同步',
      BusinessThirdAfterAdd: '新增外部售后单',
      BusinessUserRoleAllotData: '分配数据权限',
      BusinessUserRoleAllotDataCSG: '分配数据权限',
      SettingWorkflowBpmnView: '查看工作流',
      SettingFinanceStatementBaseIndex: '对账基础配置',

      BusinessMarketingActivityAdd: '添加赠品活动',
      BusinessMarketingActivityEdit: '编辑赠品活动',
      BusinessMarketingActivityView: '查看赠品活动',
      BusinessMarketingGiftAdd: '添加随品规则',
      BusinessMarketingGiftEdit: '编辑随品规则',
      BusinessMarketingGiftView: '查看随品规则',
      BusinessO2oInternalView: '内部O2O订单详情',
      BusinessO2oInternalAdd: 'O2O订单录入',
      BusinessThirdOrderAdd: '外部单录入',
      BusinessThirdO2oView: '外部O2O订单详情',
      BusinessWorksheetServiceIndex: '服务',
      BusinessWorksheetServiceView: '服务详情',
      SettingIndexesConfigListIndex: '索引配置列表',
      SettingIndexesConfigListAdd: '新增索引',
      SettingIndexesConfigListEdit: '编辑索引',
      SettingInquiryIndex: '查询配置',
      SettingInquiryAdd: '添加查询配置',
      SettingInquiryEdit: '编辑查询配置',
      SettingIndexesSyncIndex: '索引同步',
      SettingIndexesSyncAdd: '添加同步索引',
      SettingIndexesSyncEdit: '编辑同步索引',
      CommonPersonal: '个人中心',
      dingHours: '钉嵌入版工时管理',
      CommonMenu: '菜单配置',
      SettingBarcodeConfig: '条形码配置',
      BusinessAbnormalOrderUrgent_unurgent: '取消加急',
      BusinessWorkorder: '工单',
      BusinessWorkorderType: '工单类型管理',
      BusinessWorkorderList: '工单列表',
      BusinessOpenWorkorderList: '未完成工单',
      BusinessCloseWorkorderList: '已完成工单',
      BusinessWorkorderListForm: '提交工单',
      BusinessTools: '工具',
      BusinessrateCalculator: '运费计算器',
      BusinessFreightCalculationDetails: '运费计算详情',
      BusinessSendEmail: '群发邮件',
      BusinessProfitCalculator: '利润计算器',
  },
};
